export default {
  title: 'Get an online tutoring job at Ostado',
  subtitle: 'Are you a tutor seeking to find students from around the world while achieving your career goals? Ostado platform provides you with the best opportunity to work from home as an online tutor. You can also take advantage of growth opportunities both in your number of students and hourly rates.',
  img: '/front-img/start-teaching/top-banner.png'
}
